module.exports = __webpack_public_path__ + "img/w3_trash_solid_delete_light.a3d4fc6d.png";